// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OoWh","left":"styles_left__T_Y_y"};